import { render } from "./payment.vue?vue&type=template&id=2367930b&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=2367930b&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2367930b"]])

export default __exports__